var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list-item",
    {
      attrs: { "two-line": "" },
      on: {
        click: function ($event) {
          return _vm.showDetail(_vm.ordine)
        },
      },
    },
    [
      _c(
        "v-list-item-avatar",
        [
          _c(
            "v-icon",
            {
              class: [
                _vm.iconClassByProgress(_vm.ordine),
                "lighten-1",
                "white--text",
              ],
            },
            [_vm._v(_vm._s(_vm._f("statoOrdineIco")(_vm.ordine.stato)))]
          ),
        ],
        1
      ),
      _c(
        "v-list-item-content",
        [
          _c("v-list-item-title", [
            _vm._v(
              _vm._s(_vm.ordine.campionario ? "CAMPIONARIO" : "PRODUZIONE")
            ),
            _vm.ordine.firstCost == "S"
              ? _c("span", [_c("strong", [_vm._v(" USA")])])
              : _vm._e(),
            _vm._v(", Num. "),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.ordine.ordineNumero) +
                  " / " +
                  _vm._s(_vm.ordine.ordineLinea) +
                  " DEL " +
                  _vm._s(_vm._f("formatDate")(_vm.ordine.dataOrdine))
              ),
            ]),
            _vm._v(", Modello: "),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.ordine.modello.codiceParte) +
                  " - " +
                  _vm._s(_vm.ordine.modello.descrizione)
              ),
            ]),
          ]),
          _c("v-list-item-subtitle", [
            _vm.ordine.stagione
              ? _c("span", [
                  _vm._v(
                    "Stagione: " +
                      _vm._s(_vm.ordine.stagione.id) +
                      " " +
                      _vm._s(_vm.ordine.stagione.descrizione)
                  ),
                ])
              : _vm._e(),
            _vm._v(", "),
            _vm.ordine.lineaVendita
              ? _c("span", [
                  _vm._v(" Linea di vendita "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.ordine.lineaVendita.id) +
                        " - " +
                        _vm._s(_vm.ordine.lineaVendita.descrizione)
                    ),
                  ]),
                  _vm._v(","),
                ])
              : _vm._e(),
            _vm._v(" Stato "),
            _c("strong", [_vm._v(_vm._s(_vm.ordine.statoAs400))]),
            _vm._v(", Righe lavorazione: "),
            _c("strong", [_vm._v(_vm._s(_vm.ordine.lavorazioni.length))]),
          ]),
          _vm.ordine.datiAggiuntivi && _vm.ordine.datiAggiuntivi.length > 0
            ? _c(
                "v-list-item-subtitle",
                _vm._l(_vm.ordine.datiAggiuntivi, function (da, i) {
                  return da.value
                    ? _c(
                        "v-chip",
                        {
                          key: da.name,
                          class: [
                            _vm.getChipColorByHashedString(da.name),
                            "lighten-3",
                          ],
                          staticStyle: { "margin-right": "0.25rem" },
                          attrs: { label: "", small: "" },
                        },
                        [
                          _vm._v(" " + _vm._s(da.displayName) + ": "),
                          da.metadataType == _vm.metadataType.Datetime
                            ? _c("strong", [
                                _vm._v(_vm._s(_vm._f("formatDate")(da.value))),
                              ])
                            : _c("strong", [_vm._v(_vm._s(da.value))]),
                        ]
                      )
                    : _vm._e()
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-list-item-action",
        [
          _vm.ordine.note && _vm.ordine.note.length > 0
            ? _c(
                "v-tooltip",
                { attrs: { left: "" } },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "ico-stato",
                      attrs: {
                        slot: "activator",
                        color: "yellow darken-1",
                        dark: "",
                      },
                      slot: "activator",
                    },
                    [_vm._v("mdi-note")]
                  ),
                  _c("span", [_vm._v(_vm._s(_vm.ordine.note))]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }